module.exports = __webpack_public_path__ + "img/9788957981351.fa233da3.jpg";